import { Link } from "react-router-dom";
import type { DocumentDetail } from "@/briefpoint-client";

type ReviewClientTasksBreadcrumbsAndHeadingProps = {
  documentId: string;
  document: DocumentDetail | undefined;
};

export default function ReviewClientTasksBreadcrumbsAndHeading(
  props: ReviewClientTasksBreadcrumbsAndHeadingProps,
) {
  const interrogatoryCount = props.document?.interrogatories.length ?? 0;
  return (
    <>
      <div
        data-testid="review-client-tasks-breadcrumbs"
        className="bread-crumbs mb-3"
      >
        <Link to={`/wizard/${props.documentId}/${interrogatoryCount}`}>
          Review
        </Link>{" "}
        {"> Client Tasks"}
      </div>
      <div className="mb-3">
        <h1
          data-testid="review-client-tasks-header"
          className="feedback-header"
        >
          Review Client Tasks
        </h1>
      </div>
    </>
  );
}
